module.exports = __webpack_public_path__ + "assets/c21d46251463fd94e671db9b8d4e97a1.mp4";